import React from 'react';

import { config } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './light';
import './regular';
import './solid';

// Allow us to manually inject the style tag inside shadow DOM if needed
config.autoAddCss = false;

const Icons = ({
  active = false,
  className = '',
  iconName,
  prefix = '',
  title = '',
  ...rest
}) => {
  const icon = prefix ? [prefix, iconName] : iconName;
  const fontClassName = () =>
    classNames('fontawesome-icon', className, {
      'fontawesome-icon-active': active
    });

  return (
    <FontAwesomeIcon
      className={fontClassName()}
      icon={icon}
      title={title}
      {...rest}
    />
  );
};

Icons.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  iconName: PropTypes.string.isRequired,
  prefix: PropTypes.string,
  title: PropTypes.string
};

export default Icons;
